<template>
  <ul class="breadcrumb">
    <li
      v-for="(item, index) in items"
      :key="index"
      @click="$emit('update:items', items.slice(0, index + 1))"
    >
      <i
        v-if="item.icon"
        :class="item.icon"
        style="cursor:pointer;margin-right:5px;"
      ></i>
      <a
        v-if="item.text"
        style="text-transform:capitalize;text-decoration:none;cursor:pointer;"
        >{{ item.text }}</a
      >
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    items: Array
  }
};
</script>

<style>
/* Style the list */
ul {
  padding: 0px;
}
ul.breadcrumb {
  list-style: none;
  display: flex;
  justify-content: flex-start;
  margin-left: 0px;
}

/* Display list items side by side */
ul.breadcrumb li {
  font-size: 1.1em;
  color: #013243;
}

/* Add a slash symbol (/) before/behind each list item */
ul.breadcrumb li + li:before {
  padding: 8px;
  color: black;
  content: '/\00a0';
}

/* Add a color to all links inside the list */
ul.breadcrumb li a {
  text-decoration: none;
}

/* Add a color on mouse-over */
ul.breadcrumb li a:hover {
  color: #01447e;
  text-decoration: underline;
}
</style>
